var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { AnimatedImageBox } from "../ui/AnimatedImageBox.js";
import { Box } from "../ui/Box.js";
import { Button } from "../ui/Button.js";
import { Rectangle } from "../ui/Rectangle.js";
import { Text } from "../ui/Text.js";
import { TextInput } from "../ui/TextInput.js";
import { UIService } from "../ui/UIService.js";
import { Container } from "pixi.js";
import "../loader/AssetLoader.js";
import "../loader/ImageLoader.js";
import "../global-33d5eebf.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "../utils/colors.js";
import "../utils/sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../persist/persist.js";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
import "../utils/render.js";
import "../ui/UIElement.js";
import "nanoid";
import "../ui/utils.js";
import "lodash";
import "../inputs/InputManager.js";
import "../utils/playSound.js";
import "../console/flags.js";
import "../console/editor.js";
import "../components/ComponentRegistry.js";
import "../decorators/type.js";
import "ajv";
import "../utils/clone.js";
import "bitecs";
import "../utils/typehelpers.js";
import "../enums-86f58524.js";
import "../components/types.js";
import "../utils/byteArray.js";
import "../console/floatingwindow.js";
import "../Description-c36d0b9a.js";
import "../Attach-abbbd93e.js";
import "../utils/vector.js";
import "../utils/windowSessionStorage.js";
class Scene extends Container {
  constructor(pixiApp, pixiViewport) {
    super();
    __publicField(this, "_ui");
    __publicField(this, "uiElements", {});
    __publicField(this, "ui", new Proxy(this.uiElements, {
      get: (target, prop) => {
        return target[prop];
      },
      set: (target, prop, value) => {
        if (target[prop]) {
          UIService.getInstance().removeFromUI(target[prop]);
        }
        target[prop] = value;
        UIService.getInstance().addToUI(value);
        return true;
      },
      deleteProperty: (target, prop) => {
        if (!target[prop]) {
          return true;
        }
        UIService.getInstance().removeFromUI(target[prop]);
        delete target[prop];
        return true;
      }
    }));
    __publicField(this, "changeScene", () => Promise.resolve());
    __publicField(this, "timestep", "fixed");
    __publicField(this, "dt", 16.666666666666668);
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    __publicField(this, "initialize", () => {
    });
    __publicField(this, "run");
    this.pixiApp = pixiApp;
    this.pixiViewport = pixiViewport;
    this.sortableChildren = true;
    Object.entries(this.constructor.uiConfig).forEach(([key, config]) => {
      if (config.type === "text") {
        this.ui[key] = new Text(new Rectangle(config.rect), config.config);
      } else if (config.type === "button") {
        this.ui[key] = new Button(new Rectangle(config.rect), config.config);
      } else if (config.type === "textInput") {
        this.ui[key] = new TextInput(new Rectangle(config.rect), config.config);
      } else if (config.type === "animatedImageBox") {
        this.ui[key] = new AnimatedImageBox(new Rectangle(config.rect), config.config);
      } else if (config.type === "box") {
        this.ui[key] = new Box(new Rectangle(config.rect), config.config);
      }
    });
  }
  destroy(options) {
    super.destroy(options);
    this.uiElements = {};
    UIService.getInstance().clearUI();
  }
}
__publicField(Scene, "sceneName");
__publicField(Scene, "uiConfig", {});
export {
  Scene
};
//# sourceMappingURL=Scene.js.map
